import React from "react";

import SignUp from "../Components/Form/signUp";

function Signup() {
  return (
    <div>
      <SignUp />
    </div>
  );
}

export default Signup;
